import dialog from './index.vue'
dialog.install = Vue => Vue.component(dialog.name, dialog)
export default dialog
